import { Modal } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";
import { useState } from "react";

import { ModalContent } from "./components";
import { disableWelcomeModal, openWelcomeModal } from "./store";

export const WelcomeModal = () => {
  const [isOpenModal, setIsOpenModal] = useState(true);
  const [isDontShow, setIsDontShow] = useState(false);

  const [isOpenWelcomeModal] = useAtom(openWelcomeModal);
  const [, setIsDisabledWelcomeModal] = useAtom(disableWelcomeModal);

  const handleCloseWelcomeModal = () => {
    setIsDisabledWelcomeModal(isDontShow);

    setIsOpenModal((prev) => !prev);
  };

  return (
    <Modal
      open={isOpenWelcomeModal && isOpenModal}
      onClose={handleCloseWelcomeModal}
    >
      <ModalContent
        handleCloseWelcomeModal={handleCloseWelcomeModal}
        isDontShow={isDontShow}
        setIsDontShow={setIsDontShow}
      />
    </Modal>
  );
};
